<template>
  <div class="hello">
    Cihazler...
  </div>
</template>
<script src="./devices.ts"/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>